import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { navSites } from "@/mocks/navSites";
import SiteCard from "@/components/feature/SiteCard";

const tabs = [
  { id: "all", label: "全部" },
  { id: "life", label: "生活" },
  { id: "shopping", label: "购物" },
  { id: "entertainment", label: "娱乐" },
  { id: "study", label: "学习" },
  { id: "office", label: "办公" },
];

export default function HotRanking() {
  const [tab, setTab] = useState("all");

  const ranking = useMemo(() => {
    const list =
      tab === "all" ? navSites : navSites.filter((site) => site.categoryId === tab);
    return [...list].sort((a, b) => b.visits - a.visits).slice(0, 8);
  }, [tab]);

  return (
    <div>
      <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
        <div className="flex items-center gap-2">
          <span className="w-1 h-4 rounded-full bg-primary-500" />
          <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950">
            热门网址排行
          </h2>
          <span className="hidden sm:inline text-xs text-foreground-400">
            按近 30 天访问量排序
          </span>
        </div>
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-50 border border-background-200">
          {tabs.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => setTab(item.id)}
              className={`px-3 py-1 rounded-full text-xs transition-colors cursor-pointer whitespace-nowrap ${
                tab === item.id
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[1fr_360px] gap-4 md:gap-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
          {ranking.slice(0, 4).map((site) => (
            <SiteCard key={site.id} site={site} />
          ))}
        </div>

        <div className="rounded-lg bg-background-50 border border-background-200 p-2">
          <div className="flex items-center justify-between px-2 py-2">
            <span className="text-xs text-foreground-500">榜单 · 第 5 - 8 名</span>
            <Link
              to={`/category/${tab === "all" ? "life" : tab}`}
              className="text-xs text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
            >
              查看分类
            </Link>
          </div>
          <div className="space-y-1">
            {ranking.slice(4, 8).map((site, index) => (
              <SiteCard key={site.id} site={site} variant="compact" rank={index + 5} />
            ))}
          </div>
          <div className="mt-2 p-3 rounded-md bg-secondary-50 border border-secondary-100">
            <p className="text-[11px] text-secondary-800 leading-5">
              <i className="ri-information-line mr-1" />
              访问量数据为前端模拟演示，真实数据由后台统计维护。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}